export default __webpack_public_path__ + "static/illustration-dont-0c7424d09f1c6959209ff2f7b328c868.png";